export default [
  {
    categoria: "Bicicleta",
    productos: [
      {
        nombre: "Rodamiento MR",
        slug: "rodamiento-mr",
        imagen: require("@/assets/images/productos-generales/bicicleta/rodamiento-mr-bicicleta.webp"),
      },
    ],
  },
  {
    categoria: "Retenes",
    productos: [
      {
        nombre: "Nitrilo",
        slug: "nitrilo",
        imagen: require("@/assets/images/productos-generales/retenes/nitrilo.webp"),
      },
      {
        nombre: "Metálicos",
        slug: "metalicos",
        imagen: require("@/assets/images/productos-generales/retenes/metalicos.webp"),
      },
      {
        nombre: "Silicona (mvq)",
        slug: "silicona-mvq",
        imagen: require("@/assets/images/productos-generales/retenes/silicona-mvq.webp"),
      },
      {
        nombre: "Poliacrílico (acm)",
        slug: "poliacrilico-acm",
        imagen: require("@/assets/images/productos-generales/retenes/poliacrilico-acm.webp"),
      },
      {
        nombre: "Vitón (fpm)",
        slug: "viton-fpm",
        imagen: require("@/assets/images/productos-generales/retenes/viton-fpm.webp"),
      },
      {
        nombre: "Hidráulico",
        slug: "hidraulico",
        imagen: require("@/assets/images/productos-generales/retenes/hidraulico.webp"),
      },
      {
        nombre: "Tipo Ciego",
        slug: "tipo-ciego",
        imagen: require("@/assets/images/productos-generales/retenes/tipo-ciego.webp"),
      },
      {
        nombre: "Rotatorio",
        slug: "rotatorio",
        imagen: require("@/assets/images/productos-generales/retenes/rotatorio.webp"),
      },
      {
        nombre: "Tipo cassette y Combi",
        slug: "tipo-cassette-y-combi",
        imagen: require("@/assets/images/productos-generales/retenes/tipo-cassette-y-combi.webp"),
      },
    ],
  },
  {
    categoria: "Soportes / Cajas / Manguitos",
    productos: [
      {
        nombre: "Línea agrícola e industrial",
        slug: "linea-agricola-e-industrial",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/linea-agricola-e-industrial.webp"),
      },
      {
        nombre: "Chapa de acero",
        slug: "chapa-de-acero",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/chapa-de-acero.webp"),
      },
      {
        nombre: "Soportes termoplásticos",
        slug: "soportes-termoplasticos",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/soportes-termoplasticos.webp"),
      },
      {
        nombre: "Soportes inoxidables",
        slug: "soportes-inoxidables",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/soportes-inoxidables.webp"),
      },
      {
        nombre: "Cajas tipo SNK - SNU - FSAF",
        slug: "cajas-tipo-snk-snu-fsaf",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/cajas-tipo-snk-snu-fsaf.webp"),
      },
      {
        nombre: "Manguitos de fijación",
        slug: "manguitos-de-fijacion",
        imagen: require("@/assets/images/productos-generales/soportes-cajas-manguitos/manguitos-de-fijacion.webp"),
      },
    ],
  },
  {
    categoria: "Cadenas",
    productos: [
      {
        nombre: "Cadenas simple",
        slug: "cadenas-simple",
        imagen: require("@/assets/images/productos-generales/cadenas/cadenas-simple.webp"),
      },
      {
        nombre: "Doble norma bs",
        slug: "doble-norma-bs",
        imagen: require("@/assets/images/productos-generales/cadenas/doble-norma-bs.webp"),
      },
      {
        nombre: "ASA",
        slug: "asa",
        imagen: require("@/assets/images/productos-generales/cadenas/asa.webp"),
      },
      {
        nombre: "Cadenas agrícolas",
        slug: "cadenas-agricolas",
        imagen: require("@/assets/images/productos-generales/cadenas/cadenas-agricolas.webp"),
      },
      {
        nombre: "Cadenas reforzadas",
        slug: "cadenas-reforzadas",
        imagen: require("@/assets/images/productos-generales/cadenas/cadenas-reforzadas.webp"),
      },
      {
        nombre: "Cadenas inoxidables",
        slug: "cadenas-inoxidables",
        imagen: require("@/assets/images/productos-generales/cadenas/cadenas-inoxidables.webp"),
      },
    ],
  },
  {
    categoria: "Correas de Transmisión",
    productos: [
      {
        nombre: "Agrícola trapezoidal A-B-C-D-CC-BB-Z",
        slug: "agricola-trapezoidal-a-b-c-d-cc-bb-z",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/agricola-trapezoidal-a-b-c-d-cc-bb-z.webp"),
      },
      {
        nombre: "Línea automotor distribución",
        slug: "linea-automotor-distribucion",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/linea-automotor-distribucion.webp"),
      },
      {
        nombre: "Correa automotriz poly v",
        slug: "correa-automotriz-poly-v",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/correa-automotriz-poly-v.webp"),
      },
      {
        nombre: "Correa ventilador",
        slug: "correa-ventilador",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/correa-ventilador.webp"),
      },
      {
        nombre: "Correas hexagonales",
        slug: "correas-hexagonales",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/correas-hexagonales.webp"),
      },
      {
        nombre: "Correas planas",
        slug: "correas-planas",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/correas-planas.webp"),
      },
      {
        nombre: "Alto rendimiento SPA-SPB-SPC",
        slug: "alto-rendimiento-spa-spb-spc",
        imagen: require("@/assets/images/productos-generales/correas-de-transmision/alto-rendimiento-spa-spb-spc.webp"),
      },
    ],
  },
  {
    categoria: "Crucetas",
    productos: [
      {
        nombre: "Crucetas agrícolas",
        slug: "crucetas-agricolas",
        imagen: require("@/assets/images/productos-generales/crucetas/crucetas-agricolas.webp"),
      },
      {
        nombre: "Crucetas automotrices",
        slug: "crucetas-automotrices",
        imagen: require("@/assets/images/productos-generales/crucetas/crucetas-automotrices.webp"),
      },
      {
        nombre: "Soporte cardan",
        slug: "soporte-cardan",
        imagen: require("@/assets/images/productos-generales/crucetas/soporte-cardan.webp"),
      },
      {
        nombre: "Porta crucetas (yoke)",
        slug: "porta-crucetas-yoke",
        imagen: require("@/assets/images/productos-generales/crucetas/porta-crucetas-yoke.webp"),
      },
    ],
  },
  {
    categoria: "Piñones",
    productos: [
      {
        nombre: "Norma BS y ASA simple - doble - triple",
        slug: "norma-bs-y-asa-simple-doble-triple",
        imagen: require("@/assets/images/productos-generales/pinones/norma-bs-y-asa-simple-doble-triple.webp"),
      },
      {
        nombre: "En acero carbono",
        slug: "en-acero-carbono",
        imagen: require("@/assets/images/productos-generales/pinones/en-acero-carbono.webp"),
      },
      {
        nombre: "En acero inoxidable",
        slug: "en-acero-inoxidable",
        imagen: require("@/assets/images/productos-generales/pinones/en-acero-inoxidable.webp"),
      },
    ],
  },
  {
    categoria: "Ruedas Industriales",
    productos: [
      {
        nombre: "Ruedas nylon Industriales",
        slug: "ruedas-nylon-industriales",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/ruedas-nylon-industriales.webp"),
      },
      {
        nombre: "Ruedas nylon Neumáticas",
        slug: "ruedas-nylon-neumaticas",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/ruedas-nylon-neumaticas.webp"),
      },
      {
        nombre: "Ruedas nylon Poliuretano",
        slug: "ruedas-nylon-poliuretano",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/ruedas-nylon-poliuretano.webp"),
      },
      {
        nombre: "Ruedas hierro Poliuretano",
        slug: "ruedas-hierro-poliuretano",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/ruedas-hierro-poliuretano.webp"),
      },
      {
        nombre: "Rueda de goma",
        slug: "rueda-de-goma",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/rueda-de-goma.webp"),
      },
      {
        nombre: "Fijas",
        slug: "fijas",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/fijas.webp"),
      },
      {
        nombre: "Con Frenos",
        slug: "con-frenos",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/con-frenos.webp"),
      },
      {
        nombre: "Sin Frenos",
        slug: "sin-frenos",
        imagen: require("@/assets/images/productos-generales/ruedas-industriales/sin-frenos.webp"),
      },
    ],
  },
  {
    categoria: "Acoplamientos",
    productos: [
      {
        nombre: "Dodge para flex",
        slug: "dodge-para-flex",
        imagen: require("@/assets/images/productos-generales/acoplamientos/dodge-para-flex.webp"),
      },
      {
        nombre: "Omega raptor",
        slug: "omega-raptor",
        imagen: require("@/assets/images/productos-generales/acoplamientos/omega-raptor.webp"),
      },
      {
        nombre: "Rexnord",
        slug: "rexnord",
        imagen: require("@/assets/images/productos-generales/acoplamientos/rexnord.webp"),
      },
      {
        nombre: "Mecánicos tipo: I060-I075-I090-I100-I110-I150t",
        slug: "mecanicos-tipo-i060-i075-i090-i100-i110-i150t",
        imagen: require("@/assets/images/productos-generales/acoplamientos/mecanicos-tipo-i060-i075-i090-i100-i110-i150t.webp"),
      },
    ],
  },
  {
    categoria: "Cintas Transportadoras / Uniones",
    productos: [
      {
        nombre: "PVC",
        slug: "pvc",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/pvc.webp"),
      },
      {
        nombre: "Poliuretano",
        slug: "poliuretano",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/poliuretano.webp"),
      },
      {
        nombre: "Poliester",
        slug: "poliester",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/poliester.webp"),
      },
      {
        nombre: "Silicona de 1 a 6 telas",
        slug: "silicona-de-1-a-6-telas",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/silicona-de-1-a-6-telas.webp"),
      },
      {
        nombre: "Unión mecánica tipo PS125/PS187",
        slug: "union-mecanica-tipo-ps125-ps187",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/union-mecanica-tipo-ps125-ps187.webp"),
      },
      {
        nombre: "Unión mecánica tipo UX1/UX2",
        slug: "union-mecanica-tipo-ux1-ux2",
        imagen: require("@/assets/images/productos-generales/cintas-transportadoras-uniones/union-mecanica-tipo-ux1-ux2.webp"),
      },
    ],
  },
  {
    categoria: "Poleas / Bushing",
    productos: [
      {
        nombre: "Poleas para correas en V",
        slug: "poleas-para-correas-en-v",
        imagen: require("@/assets/images/productos-generales/poleas-bushing/poleas-para-correas-en-v.webp"),
      },
      {
        nombre: "Sincrónicas",
        slug: "sincronicas",
        imagen: require("@/assets/images/productos-generales/poleas-bushing/sincronicas.webp"),
      },
      {
        nombre: "Paso en pulgada",
        slug: "paso-en-pulgada",
        imagen: require("@/assets/images/productos-generales/poleas-bushing/paso-en-pulgada.webp"),
      },
      {
        nombre: "Bushing cónico tipo Americano",
        slug: "bushing-conico-tipo-americano",
        imagen: require("@/assets/images/productos-generales/poleas-bushing/bushing-conico-tipo-americano.webp"),
      },
      {
        nombre: "Bushing cónico tipo Europeo",
        slug: "bushing-conico-tipo-europeo",
        imagen: require("@/assets/images/productos-generales/poleas-bushing/bushing-conico-tipo-europeo.webp"),
      },
    ],
  },
  {
    categoria: "Neumática y Automatización",
    productos: [
      {
        nombre: "Cilindros de vástago de pistón",
        slug: "cilindros-de-vastago-de-piston",
        imagen: require("@/assets/images/productos-generales/neumatica-y-automatizacion/cilindros-de-vastago-de-piston.webp"),
      },
      {
        nombre: "Manguera neumática de poliuretano",
        slug: "manguera-neumatica-de-poliuretano",
        imagen: require("@/assets/images/productos-generales/neumatica-y-automatizacion/manguera-neumatica-de-poliuretano.webp"),
      },
      {
        nombre: "Silenciadores neumáticos",
        slug: "silenciadores-neumaticos",
        imagen: require("@/assets/images/productos-generales/neumatica-y-automatizacion/silenciadores-neumaticos.webp"),
      },
      {
        nombre: "Válvulas electroneumáticas",
        slug: "valvulas-electroneumaticas",
        imagen: require("@/assets/images/productos-generales/neumatica-y-automatizacion/valvulas-electroneumaticas.webp"),
      },
      {
        nombre: "Filtro regulador de presión",
        slug: "filtro-regulador-de-presion",
        imagen: require("@/assets/images/productos-generales/neumatica-y-automatizacion/filtro-regulador-de-presion.webp"),
      },
    ],
  },
  {
    categoria: "Motores Eléctricos / Motorreductores",
    productos: [
      {
        nombre: "Monofásico",
        slug: "monofasico",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/monofasico.webp"),
      },
      {
        nombre: "Trifásico",
        slug: "trifasico",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/trifasico.webp"),
      },
      {
        nombre: "Motorreductor Sin corona",
        slug: "motorreductor-sin-corona",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/motorreductor-sin-corona.webp"),
      },
      {
        nombre: "Motorreductor Coaxial",
        slug: "motorreductor-coaxial",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/motorreductor-coaxial.webp"),
      },
      {
        nombre: "Variadores de frecuencia",
        slug: "variadores-de-frecuencia",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/variadores-de-frecuencia.webp"),
      },
      {
        nombre: "Variadores Mecánicos",
        slug: "variadores-mecanicos",
        imagen: require("@/assets/images/productos-generales/motores-electricos-motorreductores/variadores-mecanicos.webp"),
      },
    ],
  },
  {
    categoria: "Sellos Mecánicos",
    productos: [
      {
        nombre: "Tipo cónico",
        slug: "tipo-conico",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/tipo-conico.webp"),
      },
      {
        nombre: "Largo recto",
        slug: "largo-recto",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/largo-recto.webp"),
      },
      {
        nombre: "Plano",
        slug: "plano",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/plano.webp"),
      },
      {
        nombre: "Para motobombas",
        slug: "para-motobombas",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/para-motobombas.webp"),
      },
      {
        nombre: "Tipo burgman MG1",
        slug: "tipo-burgman-mg1",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/tipo-burgman-mg1.webp"),
      },
      {
        nombre: "MG12 - MG13",
        slug: "mg12-mg13",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/mg12-mg13.webp"),
      },
      {
        nombre: "De alta presión",
        slug: "de-alta-presion",
        imagen: require("@/assets/images/productos-generales/sellos-mecanicos/de-alta-presion.webp"),
      },
    ],
  },
  {
    categoria: "Lubricantes y Selladores",
    productos: [
      {
        nombre: "Grasa multiuso",
        slug: "grasa-multiuso",
        imagen: require("@/assets/images/productos-generales/lubricantes-y-selladores/grasa-multiuso.webp"),
      },
      {
        nombre: "Grasa ep2",
        slug: "grasa-ep2",
        imagen: require("@/assets/images/productos-generales/lubricantes-y-selladores/grasa-ep2.webp"),
      },
      {
        nombre: "Para rodamientos Adhesivos y Fijadores",
        slug: "para-rodamientos-adhesivos-y-fijadores",
        imagen: require("@/assets/images/productos-generales/lubricantes-y-selladores/para-rodamientos-adhesivos-y-fijadores.webp"),
      },
      {
        nombre: "Grado alimenticio",
        slug: "grado-alimenticio",
        imagen: require("@/assets/images/productos-generales/lubricantes-y-selladores/grado-alimenticio.webp"),
      },
      {
        nombre: "Químicos automotrices",
        slug: "quimicos-automotrices",
        imagen: require("@/assets/images/productos-generales/lubricantes-y-selladores/quimicos-automotrices.webp"),
      },
    ],
  },
  {
    categoria: "Seguros Segers / Arandelas",
    productos: [
      {
        nombre: "Seguros segers externo DIN471",
        slug: "seguros-segers-externo-din471",
        imagen: require("@/assets/images/productos-generales/seguros-segers-arandelas/seguros-segers-externo-din471.webp"),
      },
      {
        nombre: "Seguros segers internos DIN472",
        slug: "seguros-segers-internos-din472",
        imagen: require("@/assets/images/productos-generales/seguros-segers-arandelas/seguros-segers-internos-din472.webp"),
      },
    ],
  },
  {
    categoria: "O-Rings",
    productos: [
      {
        nombre: "O-Rings de sellado industriales",
        slug: "o-rings-sellado-industriales",
        imagen: require("@/assets/images/productos-generales/orings/o-rings-sellado-industriales.webp"),
      },
    ],
  },
];
